'use strict';

import React from 'react';
import Iframe from '../../IFrame';
import Api from '../../../api/Api';
import Loader from '../../Loader';
import Urls from '../../../definitions/Urls';
import iFrameNavigationListener from '../../../listener/iFrameNavigationListener';
import { QUESTIONNAIRES } from '../../../data/reducer';
import { connect } from 'react-redux';
import { getQuestionnaires } from '../../../data/questionnaires/actions';
import { setLastActive } from "../../../data/session/actions";

class AssignedCareRequest extends React.Component {
  constructor(props) {
    super(props);

    // initialize trusted context as empty
    this.state = { trustedContext: '', iframeStatus: null };
    this.queryBaseUrl =
      Urls.medixineApi() + '/signin-trustedcontext-fi?_trustedContextToken=';
  }

  componentDidMount() {
    // when component mounts, get recent trusted context.
    Api.getTrustedContext().then((ctx) => {
      this.setState({ trustedContext: ctx });
    });

    window.addEventListener('message', iFrameNavigationListener(this.props.setLastActive));
  }

  /*
   * When we move away from filling a carerequest, we do not know anything from it's state since it's in an iframe.
   * This is why we need to update/fetch new state of carerequests when we leave view. Questionnaires are handled
   * from the root component so the function is passed as props
   * */
  componentWillUnmount() {
    this.props.getQuestionnaires();
    window.removeEventListener('message', iFrameNavigationListener);
  }

  iframeLoaded = () => {
    this.setState({ iframeStatus: 'loaded' });
    // scroll window to top after navigation. This is also called when navigation happens inside iframe
  };

  render() {
    let { trustedContext } = this.state;
    let {
      match: {
        params: { appointmentId, systemName },
      },
    } = this.props;

    if (!trustedContext) {
      return <Loader />;
    }

    let url = this.queryBaseUrl.concat(
      trustedContext,
      '&ReturnUrl=',
      encodeURIComponent(
        '/Q/' +
          systemName +
          (appointmentId && appointmentId !== ''
            ? '?appointmentId=' + appointmentId
            : '')
      )
    );
    return (
      <div className="ot-mainview">
        {this.state.iframeStatus === null && <Loader />}
        <Iframe
          url={url}
          width="100%"
          height="1000px"
          display="initial"
          position="relative"
          allowFullScreen
          onLoad={() => this.iframeLoaded()}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state[QUESTIONNAIRES].data,
  };
};

export default connect(mapStateToProps, { getQuestionnaires, setLastActive })(
  AssignedCareRequest
);
